<template>
  <tbody>
    <ValidationObserver v-slot="{ invalid }">
      <tr class="d-flex" v-for="(bonusRate, index) in bonusRates" :key="bonusRate.bonusType">
        <td class="col-2">
          <button class="record font-weight-bold" disabled>{{index+1}}</button>
        </td>
        <td class="col-3">
          <button class="record" disabled>{{bonusRate.bonusType}}</button>
        </td>
        <td class="col-3 d-flex justify-content-center">
          <button v-if="!isUpdateMode || selectedBonusRateIndex !== index" class="record" disabled>{{bonusRate.percentage}}%</button>
          <NumberInputField  labelText="percentage" minValue=0 maxValue=100 v-if="isUpdateMode && selectedBonusRateIndex === index" v-model="updatedPercentage" :hideLabel="true" :required="true"/>
        </td>
        <td class="col-4">
          <button v-if="!isUpdateMode || selectedBonusRateIndex !== index" class="btn-basic btn-outline-pulse" style="width: 200px;" @click="enableUpdateMode(bonusRate.percentage, index)">Percentage aanpassen</button>
          <button :disabled="isSaving || invalid" v-if="isUpdateMode && selectedBonusRateIndex === index" class="btn-basic btn-fill-pulse mr-1" @click="save(bonusRate.bonusType)">Opslaan</button>
          <button :disabled="isSaving" v-if="isUpdateMode && selectedBonusRateIndex === index" class="btn-basic btn-fill-pulse-dark ml-1" @click="disableUpdateMode()">Annuleren</button>
        </td>
      </tr>
    </ValidationObserver>
  </tbody>
</template>

<script>
import NumberInputField from "@/components/inputFields/NumberInputField";
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
export default {
  name: "BonusTypesPreviewComponent",
  components: {NumberInputField, ValidationObserver},
  props: ["bonusRates"],
  data: () => ({
    selectedBonusRateIndex: -1,
    isUpdateMode: false,
    isSaving: false,
    updatedPercentage: 15
  }),
  methods: {
    ...mapActions("administrationCustomer", ["updateBonusRateFromCustomer", "fetchDetailsForSelectedCustomer"]),
    enableUpdateMode(percentage, index) {
      this.isUpdateMode = true;
      this.updatedPercentage = percentage;
      this.selectedBonusRateIndex = index;
    },
    disableUpdateMode() {
      this.isUpdateMode = false;
    },
    async save(bonusType) {
      this.isSaving = true;
      const percentage = this.updatedPercentage;
      const updateBonusRateDto = {
        bonusType, percentage
      };
      await this.updateBonusRateFromCustomer(updateBonusRateDto)
          .then(() => {
            this.isSaving = false;
            this.isUpdateMode = false;
            this.fetchDetailsForSelectedCustomer();
          }).catch(() => {
            this.isSaving = false;
            this.isUpdateMode = false;
          });
    }
  }
};
</script>

<style scoped>
.record {
  width: 140px;
  cursor: default;
  outline: 0;
  color: black;
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 16px;
  border-radius: .25rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  background-color: transparent;
}
</style>